export default __webpack_public_path__ + "static/media/orange.ef5cb76b.svg";